// extracted by mini-css-extract-plugin
export var modal = "_di-0";